import { useEffect, useState } from "react"
import { useEntidad, useForm, useFormErrors, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { DatePickerCustom, FormError, FormLabel, InputEntidad, SectionHeading } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"

import { VALIDATION_MESSAGE } from "../../consts/validationMessage"
const importacionInit = {
    fechaDesde: null,
    fechaHasta: null,
}

const FECHA_MINIMA = new Date(2026, 0, 1)

const DevolucionImportacionView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [importacion_formValues, importacion_formHandle, importacion_formReset] = useForm(importacionInit, 'importacion_')
    const [idRecaudadora, setIdRecaudadora] = useState(0)

    const [getListEntidad] = useEntidad({
        entidades: ['Recaudadora'],
        onLoaded: (_, isSuccess, error) => {
          if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
        },
        memo: { key: 'Recaudadora', timeout: 0 }
    })

    useEffect(() => {
        const list = getListEntidad('Recaudadora')
        if (list) {
            const epagos = list.find(r => r.codigoCliente === 'E-PAGOS-DEVOLUCIONES' || r.codigo === '99')
            if (epagos) setIdRecaudadora(epagos.id)
        }
    }, [getListEntidad])

    const ImportarDevolucion = () => {
        setIsLoading(true)

        const dataBody = {
            fechaDesde: importacion_formValues.fechaDesde,
            fechaHasta: importacion_formValues.fechaHasta,
        }

        const paramsUrl = `/async/E-PAGOS-DEVOLUCIONES`

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.IMPORTADOR,
            paramsUrl,
            dataBody,
            res => res.json().then(data => {
                ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'El proceso fue iniciado correctamente')
                importacion_formReset()
                reset()
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const getErrors = () => {
        const errors = {}
        if (!importacion_formValues.fechaDesde) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE
        if (!importacion_formValues.fechaHasta) errors.fechaHasta = VALIDATION_MESSAGE.REQUIRED_DATE
        return errors
    }

    const { errorOf, validate, reset } = useFormErrors(getErrors)

    const handleImportar = () => {
        if (!validate()) return

        showMessageModal({
            title: "Confirmación",
            message: "¿Está seguro/a de importar?",
            onConfirm: () => ImportarDevolucion(),
        })
    }

    return <>
        <SectionHeading titles={[{ title: 'Devoluciones' }, { title: 'Importación de devoluciones' }]} />

        <section className='section-accordion'>
            <div>
                <div className="row form-basic">
                    <div className="col-12 col-md-4">
                        <label htmlFor="importacion_idRecaudadora" className="form-label">Recaudadora</label>
                        <InputEntidad
                            name="importacion_idRecaudadora"
                            placeholder=""
                            className="form-control"
                            value={idRecaudadora}
                            entidad="Recaudadora"
                            disabled={true}
                        />
                        <FormError />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="importacion_fechaDesde" required>Fecha desde</FormLabel>
                        <DatePickerCustom
                            name="importacion_fechaDesde"
                            placeholder=""
                            className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                            value={importacion_formValues.fechaDesde}
                            onChange={importacion_formHandle}
                            minValue={FECHA_MINIMA}
                        />
                        <FormError message={errorOf('fechaDesde')} />
                    </div>
                    <div className="col-12 col-md-2">
                        <FormLabel htmlFor="importacion_fechaHasta" required>Fecha hasta</FormLabel>
                        <DatePickerCustom
                            name="importacion_fechaHasta"
                            placeholder=""
                            className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                            value={importacion_formValues.fechaHasta}
                            onChange={importacion_formHandle}
                            minValue={importacion_formValues.fechaDesde || FECHA_MINIMA}
                        />
                        <FormError message={errorOf('fechaHasta')} />
                    </div>
                </div>
            </div>
        </section>

        <footer className='footer footer-action'>
            <div className='footer-action-container'>
                <button className="btn action-button float-end" onClick={ (event) => handleImportar() }>Importar</button>
            </div>
        </footer>

    </>
}

export default DevolucionImportacionView
